module.exports = __webpack_public_path__ + "img/widget_v001.6639b438.png";